import { render } from "./VersionControlInput.vue?vue&type=template&id=51cdbfd4"
import script from "./VersionControlInput.vue?vue&type=script&lang=js"
export * from "./VersionControlInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__